import styled from "styled-components";

export const Styles = styled.div<{
  $borderColor?: string;
  $textColor?: string;
  $background?: string;
}>`
  border: 1px solid ${(p) => p.$borderColor ?? "#52c41a"};
  background: ${(p) => p.$background ?? "#f6ffed33"};
  backdrop-filter: blur(12px);
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 0 8px;
  height: 20px;
  gap: 4px;
  border-radius: 4px;
  color: ${(p) => p.$textColor ?? "#52c41a"} !important;
`;
